import { render, staticRenderFns } from "./IchingCenters.vue?vue&type=template&id=a8c719c6&"
import script from "./IchingCenters.vue?vue&type=script&lang=js&"
export * from "./IchingCenters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports